import script from "./MessageUploadQueue.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageUploadQueue.vue?vue&type=script&setup=true&lang=ts"

import "./MessageUploadQueue.vue?vue&type=style&index=0&id=799ddf60&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-799ddf60"]])

export default __exports__